<template>
	<div
		class="grid col-span-full gap-2 p-4 max-w-screen-2xl mx-auto"
		:class="{
			'sm:grid-cols-3 xl:grid-cols-7': schedule.length === 6,
			'sm:grid-cols-3 xl:grid-cols-6': schedule.length === 6,
			'sm:grid-cols-3 xl:grid-cols-5': schedule.length === 5,
			'sm:grid-cols-3 xl:grid-cols-4': schedule.length <= 4,
		}"
	>
		<div
			v-for="day in schedule"
			:key="day.day"
			class="p-2 even:bg-gray-50/90 odd:bg-gray-50/80 rounded flex flex-col gap-4"
		>
			<AtomTitle
				tag="h2"
				size="md"
				class="px-2 pt-1"
			>
				{{ day.day }}
			</AtomTitle>
			<div
				v-for="time in day.times"
				:key="`${day.day}-${time.title}`"
				class="flex items-center justify-between p-2 pr-4 gap-2 bg-white shadow-sm rounded"
			>
				<time
					:datetime="`${time.from}-${time.till}`"
					:aria-label="`Trainingstijd ${day.day} ${time.title} van ${time.from} tot ${time.till}`"
					class="text-functional-size-md flex flex-col gap-1"
				>
					<span>{{ time.title }}</span>
					<span class="text-functional-size-sm text-gray-800">{{ time.from }} - {{ time.till }}</span>
				</time>
				<AtomLink
					v-if="trainingInfoUrls[time.title]"
					:url="trainingInfoUrls[time.title] as string"
					:title="`Meer informatie over ${time.title}`"
				>
					<AtomFontAwesome
						class="size-7 text-gray-500"
						icon="fa-info-circle"
					/>
				</AtomLink>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import type { SubscriptionScheduleDayType } from '#base/core/types/SubscriptionTypes';

defineProps<{
	schedule: SubscriptionScheduleDayType[];
}>();

const trainingInfoUrls: Record<string, string> = {
	'Functional Conditioning': '/small-group-training/functional-conditioning-conditietraining',
	'Functional Strength': '/small-group-training/functional-strength-krachttraining',
	'LifeFit': '/small-group-training/lifefit-functionele-begeleide-fitness',
};
</script>
